import RedirectToCheckout from '@/components/global/RedirectToCheckout';
import CurrencyIcon from '@/components/ui/icons/currency-icon';
import { handlePriceByComma } from '@/helpers/common';

const SmallCart = ({
  t,
  isPanelOpen,
  togglePanel,
  togglePopup,
  isLoading,
  totalSegments,
}) => {
  const totalValue = totalSegments?.find(
    (e) => e?.code === 'grand_total'
  )?.value;

  return (
    <div
      className={`md:min-w-[280px] ${isPanelOpen ? 'hidden' : 'flex'} items-center gap-2.5 border border-gray-200 bg-white p-3 transition md:rounded-2xl md:shadow-lg`}
    >
      <button
        className='grid size-[35px] h-[35p] cursor-pointer place-items-center rounded-xl border border-[#e2e8f0] bg-[#f8fafc] text-[18px] text-[#64748b] md:size-[42px]'
        id='pillToggle'
        title='عرض التفاصيل'
        onClick={togglePanel}
      >
        ▲
      </button>
      <div className='flex flex-1 flex-col leading-[1.15]'>
        <span className='text-[12px] text-[#64748b]'>{t('Total')}</span>
        <span
          className={`mt-0.5 flex items-center gap-1 font-extrabold whitespace-nowrap tabular-nums ${totalValue <= 0 && 'text-green-500'}`}
        >
          {isLoading ? (
            <div className='flex items-center gap-1'>
              <div className='mt-1 h-4 w-16 animate-pulse rounded bg-gray-200'></div>
            </div>
          ) : (
            <>
              {handlePriceByComma(totalValue ?? 0)}
              <CurrencyIcon className='size-3' />
            </>
          )}
        </span>
      </div>

      <RedirectToCheckout togglePopup={togglePopup} type={'fromSmallCart'} />
    </div>
  );
};

export default SmallCart;
